import { CrudFilters, HttpError } from "@refinedev/core";
import { List, TextField, useTable, getDefaultSortOrder, EditButton, ShowButton } from "@refinedev/antd";
import { Form, Table, Space, Input, Button, Tag } from "antd";
import { AdminPodcastInfo } from "interfaces";

interface PodcastFilterVariables {
  search: string
}

export const PodcastList: React.FC = () => {
  const { tableProps, sorters, searchFormProps } = useTable<AdminPodcastInfo, HttpError, PodcastFilterVariables>({
    onSearch: (params) => {
      const filters: CrudFilters = [];
      const { search } = params;

      filters.push(
          {
              field: "search",
              operator: "eq",
              value: search,
          },
      );

      return filters;
    },

    sorters: {
      initial: [
        {
          field: "id",
          order: "desc",
        },
      ]
    }
  });

  return (
    <List>
      <Form
          {...searchFormProps}
          layout="vertical"
          // onValuesChange={() => searchFormProps.form?.submit()}
      >
          <Space wrap>
              <Form.Item name="search">
                <Input />
              </Form.Item>
              <Form.Item>
                <Button onClick={() => searchFormProps.form?.submit()}>Search</Button>
              </Form.Item>
              
          </Space>
      </Form>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          dataIndex="itunes_id"
          key="itunes_id"
          title="iTunes ID"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("itunes_id", sorters)}
          sorter
        />
        <Table.Column
          dataIndex="title"
          key="title"
          title="Title"
          render={(value) => <TextField value={value} />}
          defaultSortOrder={getDefaultSortOrder("title", sorters)}
          sorter
        />
        <Table.Column
            dataIndex="author"
            key="author"
            title="Author"
            render={(value) => <TextField value={value} />}
            defaultSortOrder={getDefaultSortOrder("author", sorters)}
            sorter
        />
        <Table.Column<AdminPodcastInfo>
          dataIndex="is_deleted"
          key="is_deleted"
          title="Status"
          render={(_, record) =>
            record.is_deleted
              ? <Tag color="red">Deleted</Tag>
              : <Tag color="green">Live</Tag>
          }
        />
        <Table.Column<AdminPodcastInfo>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton hideText size="small" recordItemId={record.id} />
              <ShowButton hideText size="small" recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
